import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { LifecycleAware } from '@lsq-frontend/common-ui';
import { ClaimService } from '@lsq-frontend/common-ui';
import {
    GetSupplierBasicInformationRequest,
    GetSupplierBasicInformationResponse,
    GetSupplierBasicInformationService
} from '@lsq-frontend/remote-services/all-java/financing-mk2-services/buyer-account/supplier-details/get-supplier-basic-information';

import { take } from 'rxjs/operators';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { I18n } from '@ngx-translate/i18n-polyfill';

@LifecycleAware()
@Component({
    selector: 'supplier-details',
    template: `
        <page-header
            [titleText]="basicInformation?.name!"
            [backButtonText]="backText"
            (handleBackButtonClick)="navigateBack()"
        ></page-header>
        <div class="container-fluid page-container">
            <supplier-basic-information
                [style.display]="'block'"
                [style.marginBottom]="'3rem'"
                [basicInformation]="basicInformation"
            ></supplier-basic-information>
            <supplier-contacts-table
                [style.display]="'block'"
                [style.marginBottom]="'3rem'"
            ></supplier-contacts-table>

            <div class="row">
                <div class="col-12 col-md-6" [style.marginBottom]="'3rem'">
                    <supplier-details-open-invoices></supplier-details-open-invoices>
                </div>
                <div class="col-12 col-md-6" [style.marginBottom]="'3rem'">
                    <supplier-program-information></supplier-program-information>
                </div>
            </div>
        </div>
    `
})
export class SupplierDetailsComponent implements OnInit, OnDestroy {
    public basicInformation!: GetSupplierBasicInformationResponse;
    public isFinancingAccountPortalUser = false;
    public backButtonText$: Observable<string>;

    public readonly backText = this._i18n('Back');

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _getSupplierBasicInformation: GetSupplierBasicInformationService,
        private _claimService: ClaimService,
        private _i18n: I18n,
        private location: Location
    ) {}

    public ngOnDestroy(): void {}

    public async ngOnInit(): Promise<void> {
        this.isFinancingAccountPortalUser = this._claimService.isOnSync(
            DashboardClaim.FinancingAccountPortal
        );
        const params = await this._activatedRoute.params.pipe(take(1)).toPromise();

        try {
            this.basicInformation = await this._getSupplierBasicInformation.executeOnce(
                new GetSupplierBasicInformationRequest({
                    supplierKey: params.sellerKey
                })
            );
        } catch (e) {
            this.navigateBack();
        }
    }

    public navigateBack(): void {
        this.location.back();
    }
}
